import { styled } from "@mui/material";

export const LabelText = styled("span")(() => ({
  fontSize: "14px"
}));

export const LabelRequiedAsterisk = styled("span")(() => ({
  color: "#D32F2F"
}));
